import { useSelector, useDispatch } from "react-redux";
import { useMount } from "app/custom-hooks/useMount";
import { selectLegacyWorkspaceId } from "../../common/store/selectors";
import { fetchWorkspacesThunk } from "../../common/store/effects";

export const useFetchOpportunityListsIfNotPresent = () => {
    const dispatch = useDispatch();
    const workspaceId = useSelector(selectLegacyWorkspaceId);

    useMount(() => {
        if (!workspaceId) {
            dispatch(fetchWorkspacesThunk());
        }
    });
};
